import { render, staticRenderFns } from "./FormProductSaleCount.vue?vue&type=template&id=56733922&"
import script from "./FormProductSaleCount.vue?vue&type=script&lang=js&"
export * from "./FormProductSaleCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports